import styled from 'styled-components';
import { InputNumber, Radio } from 'antd';

export const ResponsiveRadioGroup = styled(Radio.Group)`
  display: flex;
  width: 100%;

  .ant-radio-button-wrapper {
    flex: 1;
    text-align: center;
  }
`;

export const StyledRadioButton = styled(Radio.Button)<{
  position: 'left' | 'right';
}>`
  width: 100%;

  && {
    border-radius: 8px !important;

    @media (min-width: 388px) {
      border-radius: ${props =>
        props.position === 'left'
          ? '8px 0 0 8px !important'
          : '0 8px 8px 0 !important'};
    }
  }
`;

export const CustomInputNumber = styled(InputNumber).attrs({
  decimalSeparator: ',',
})`
  input::placeholder {
    color: ${props => (props.theme.title === 'dark' ? '#474e4e' : '#e2e5e4')};
  }
`;
